import { motion } from "framer-motion";
import { openClose } from "@/utils/motion/open-close.ts";
import { FeedbackProps } from "@/types";
import { useTranslation } from "react-i18next";
import { useModalAction } from "@/contexts/modal/Context.tsx";
import { FEEDBACK_EVENT_ID } from "@/utils/agenda.ts";
import { useCreateAgendaFeedbackMutation } from "@/data/feedback.ts";
import Textarea from "@edusogno/primitives/textarea";
import LoadingButton from "@edusogno/primitives/loading-button";

interface SecondPageProps {
  feedback: FeedbackProps;
  nextPage: () => void;
  comment: string | undefined;
  setComment: (comment: string) => void;
}

const DesktopFeedbackSecondPage = ({
  setComment,
  feedback,
  comment,
  nextPage,
}: SecondPageProps) => {
  const { closeModal } = useModalAction();
  const { t } = useTranslation();
  const { mutate, isLoading } = useCreateAgendaFeedbackMutation(() => {
    closeModal();
    localStorage.removeItem(FEEDBACK_EVENT_ID);
  });
  return (
    <>
      <motion.div
        className="flex flex-col h-full justify-between w-full"
        variants={openClose()}
      >
        <div className={"text-primary h-full"}>
          <h3 className="text-2xl font-semibold text-center">
            {t("feedback.great_work")}
          </h3>
          <h3 className="text-2xl font-semibold text-center">
            {t("feedback.talk_to_us")}
          </h3>
        </div>
        <div className="h-full w-full">
          <Textarea
            className={"h-40"}
            placeholder={t("feedback.comment_placeholder")}
            onChange={(event) => {
              setComment(event.target.value);
            }}
          />
        </div>
      </motion.div>

      <motion.div
        variants={openClose()}
        className="flex flex-col justify-center items-center mt-4"
      >
        <LoadingButton
          size={"md"}
          variant="contained"
          color="green"
          loading={isLoading}
          disabled={!comment || isLoading}
          onClick={() => {
            if (
              feedback.rating.tutor < 4 ||
              feedback.rating.topicAndOrganization < 4
            ) {
              if (nextPage) nextPage();
            } else {
              if (comment) {
                mutate({
                  ...feedback,
                  first_feedback: comment,
                });
              }
            }
          }}
        >
          {t("btns.send")}
        </LoadingButton>
      </motion.div>
    </>
  );
};

export default DesktopFeedbackSecondPage;
